<template>
  <div class="relative h-24px w-24px cursor-pointer" @click="redirect">
    <i class="icon-cart text-24px" />
    <p
      v-if="totalQuantity > 0"
      class="absolute h-12px w-12px flex items-center justify-center rounded-full bg-brand-deep-yellow text-10px text-white -right-2px -top-2px"
    >
      {{ totalQuantity }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useCartStore } from '@/store/cartStore'
import { pushGA4ViewCart } from '@/utils/googleAnalytics'
import { redirectOfficialCartPage } from '@/utils/redirect'

function redirect(): void {
  pushGA4ViewCart()
  redirectOfficialCartPage()
}

const { totalQuantity } = storeToRefs(useCartStore())
</script>
